// src/Firebase/userService.js
import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "./firebaseconfig";

// Si no existe, crea el documento del usuario con rol por defecto
export const crearUsuarioSiNoExiste = async (firebaseUser) => {
  const ref = doc(db, "usuarios", firebaseUser.uid);
  const snap = await getDoc(ref);
  if (!snap.exists()) {
    await setDoc(ref, {
      nombre: firebaseUser.displayName || "",
      correo: firebaseUser.email,
      rol: "vendedor"  // rol por defecto
    });
  }
};

// Obtiene los datos del usuario (incluye rol)
export const obtenerUsuario = async (uid) => {
  const ref = doc(db, "usuarios", uid);
  const snap = await getDoc(ref);
  return snap.exists() ? snap.data() : null;
};
